import { superstyled } from '@zenbusiness/zui/styles';

export const Site = superstyled({
  name: 'AppContainer',
  slot: 'Site',
  propsNeeded: ['isWebView'],
  styles: ({ theme, isWebView }) => ({
    '--nav-width': isWebView ? '0rem' : '5.75rem', // Prevent Nav bar padding on WebView's
    '--nav-width-wide': '17.5rem',

    background: theme.palette.background.default,
    position: 'relative',
    transition: theme.transitions.create(['transform'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),

    'body.drawer-open &': {
      transform: 'translateX(var(--nav-width-wide))'
    },

    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: 'var(--nav-width) 1fr',
      gridTemplateAreas: '"nav content"',

      'body.drawer-open &': {
        transform: 'none'
      }
    }
  })
});

export const Navigation = superstyled({
  name: 'AppContainer',
  slot: 'Navigation',
  styles: ({ theme }) => ({
    gridArea: 'nav',
    height: '100dvh',
    overflow: 'hidden',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 'calc(-1 * var(--nav-width-wide))', // creates a negative CSS var value.
    width: 'var(--nav-width-wide)',
    zIndex: theme.zIndex.drawer,

    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: 0,
      transition: 'width ease-in-out 0.3s',
      width: 'var(--nav-width)',

      '&:hover, &:focus-within': {
        width: 'var(--nav-width-wide)'
      }
    }
  })
});

export const Content = superstyled({
  name: 'AppContainer',
  slot: 'Content',
  styles: ({ theme }) => ({
    gridArea: 'content',
    // Push footer to bottom of viewport on mobile when there is little to no content (e.g. loading).
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100dvh',
    marginTop: 0,

    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateRows: 'auto 1fr',
      gridTemplateColumns: 'minmax(0, 1fr) auto'
    }
  })
});

export const Header = superstyled({
  name: 'AppContainer',
  slot: 'Header',
  propsNeeded: ['isObo'],
  styles: ({ theme, isObo }) => ({
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    zIndex: theme.zIndex.appBar,
    ...(isObo && {
      paddingTop: theme.spacing(5)
    }),
    [theme.breakpoints.up('md')]: {
      gridRow: '1 / 2',
      gridColumn: '2 / 3',
      position: 'sticky',
      top: '0'
    },
    [theme.breakpoints.down('md')]: {
      background: theme.palette.common.black,
      color: theme.palette.common.white,
      paddingBottom: 0
    }
  })
});

export const Selector = superstyled({
  name: 'AppContainer',
  slot: 'Selector',
  propsNeeded: ['isObo'],
  styles: ({ theme, isObo }) => ({
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    position: 'sticky',
    top: '0',
    zIndex: theme.zIndex.appBar,

    [theme.breakpoints.up('md')]: {
      gridRow: '1 / 2',
      gridColumn: '1 / 2',
      ...(isObo && {
        paddingTop: theme.spacing(5)
      })
    },
    [theme.breakpoints.down('md')]: {
      background: theme.palette.common.black,
      color: theme.palette.common.white,
      paddingTop: theme.spacing(0)
    }
  })
});

export const Main = superstyled({
  name: 'AppContainer',
  slot: 'Main',
  styles: ({ theme }) => ({
    flexGrow: 1,
    paddingInline: theme.spacing(1),
    paddingTop: theme.spacing(4),

    [theme.breakpoints.up('md')]: {
      flexBasis: '100%',
      paddingInline: '5%',
      gridColumn: '1 / 3'
    }
  })
});

export const Footer = superstyled({
  name: 'AppContainer',
  slot: 'Footer',
  styles: ({ theme }) => ({
    paddingInline: theme.spacing(1),

    [theme.breakpoints.up('md')]: {
      gridColumn: '1 / 3',
      paddingInline: '5%'
    }
  })
});
